const getters = {
  isVehicleSelected: (state) => (vehicleUUID) => {
    return state.selectedVehicles[vehicleUUID] !== undefined;
  },
};

export { getters };
